// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-menu {\n  background-color: var(--v-primary-base);\n  border-radius: 8px !important;\n  padding: 4px 4px;\n  height: 40px;\n}\n.tab-menu .tab-btn {\n  height: 100%;\n}\n.tab-menu .tab-btn .tab-btn-text {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 27px;\n}", ""]);
// Exports
module.exports = exports;
